/* mff-clean-urls.js (Oct 2026) - keeps product addresses short.

   1. Product links on some collection pages carry the collection in the path
      (/collections/foot-function/products/toe-separators). They are pointed at
      the product's own address (/products/toe-separators). It is the same
      page, and Shopify's canonical tag already names the short address.

   2. Shopify adds tracking parameters when a shopper arrives from search
      results or a "recommended" card (?_pos=..&_sid=.. or ?pr_prod_strat=..).
      They only matter for the page view recorded on arrival, so they are taken
      out of the address bar once the page has loaded. Anything the shopper
      copies or shares afterwards is the short address.

   3. A search-result link that was pasted into a menu or page by hand keeps
      its stale search parameters for ever. Those are removed from the link.

   Left alone on purpose: ?variant= (it selects the variant) and marketing
   parameters such as utm_*, fbclid, gclid, srsltid and _kx. */
(function () {
  var DROP = ['pr_prod_strat', 'pr_rec_id', 'pr_rec_pid', 'pr_ref_pid', 'pr_seq', '_pos', '_sid', '_ss', '_psq', '_psid', '_v'];
  var PREFIXED = new RegExp('^((?:/[a-z]{2}(?:-[a-z]{2,4})?)?)/collections/[^/]+(/products/[^/?#]+)/?$', 'i');

  function shortPath(path) {
    var m = path.match(PREFIXED);
    return m ? m[1] + m[2] : null;
  }

  function dropParams(u) {
    var changed = false;
    DROP.forEach(function (k) {
      if (u.searchParams.has(k)) { u.searchParams.delete(k); changed = true; }
    });
    return changed;
  }

  function cleanAddress() {
    try {
      var u = new URL(window.location.href);
      var p = shortPath(u.pathname);
      var changed = false;
      if (p) { u.pathname = p; changed = true; }
      if (dropParams(u)) changed = true;
      if (changed && window.history && history.replaceState) {
        history.replaceState(history.state, '', u.pathname + u.search + u.hash);
      }
    } catch (e) {}
  }

  function fixLink(a) {
    try {
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) === '#') return;
      var u = new URL(href, window.location.href);
      if (u.origin !== window.location.origin) return;
      var changed = false;
      var p = shortPath(u.pathname);
      if (p) { u.pathname = p; changed = true; }
      /* live search links always carry a session id; one without it was pasted in by hand */
      if (u.searchParams.has('_psq') && !u.searchParams.has('_psid') && !u.searchParams.has('_sid')) {
        if (dropParams(u)) changed = true;
      }
      if (changed) a.setAttribute('href', u.pathname + u.search + u.hash);
    } catch (e) {}
  }

  function fixLinks(root) {
    var list = (root || document).querySelectorAll('a[href*="/collections/"][href*="/products/"], a[href*="_psq="]');
    for (var i = 0; i < list.length; i++) fixLink(list[i]);
  }

  /* links added later (filters, load more, drawers) are fixed just before they are followed */
  function onPress(e) {
    var t = e.target;
    var a = t && typeof t.closest === 'function' ? t.closest('a[href]') : null;
    if (a) fixLink(a);
  }
  ['pointerdown', 'touchstart', 'click'].forEach(function (type) {
    document.addEventListener(type, onPress, { passive: true, capture: true });
  });

  var cleaned = false;
  function cleanSoon() {
    if (cleaned) return;
    cleaned = true;
    setTimeout(cleanAddress, 400);
  }

  function boot() {
    fixLinks(document);
    if (document.readyState === 'complete') cleanSoon();
    else {
      window.addEventListener('load', cleanSoon);
      setTimeout(cleanSoon, 5000); /* never wait for ever on a slow third-party file */
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
